<template>
  <div class="shop-import">
    <div class="title">请导入EXCLE格式文件</div>
    <div class="import-area">
      <input ref="excel-upload-input" class="excel-upload-input" type="file" accept=".xlsx, .xls" @change="handleClick">
      <div class="drop" @drop="handleDrop" @dragover="handleDragover" @dragenter="handleDragover">
        <i class="el-icon-plus"></i>
        <span>或将Excle文件拖拽到这里</span>
        <div class="btn-box">
          <el-button :loading="loading" type="primary" @click="handleUpload">上传文件</el-button>
          <el-button class="mr10" @click="onDownloadTemplate" >下载模板文件</el-button>
        </div>
      </div>
    </div>

    <div class="title">店铺导览</div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :pagination="false"
    >
      <template #mallId="{ row }">
        <el-select v-model="row.mallId" placeholder="请选择商场">
          <el-option v-for="item in mallData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </template>
      <template #name="{ row }">{{ row.name }}</template>
      <template #refId="{ row }">{{ row.refId }}</template>
      <template #category="{ row }">
        <el-cascader
          v-model="row.category"
          placeholder="请选择所属业态"
          :options="shopCategoryData"
          :props="categoryCascaderProps"
          clearable
        >
        </el-cascader>
      </template>
    </Table>
    <div class="footer">
      <el-button @click="$router.back(-1)" class="mr20">取消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="submitLoading">提交</el-button>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import Table from "@/components/Table/index";
import { downFile } from '@/utils'
import { api_getShopTempDown, api_postShopBatchAdd } from '@/api/shop'
import { api_getConfig } from '@/api/common'
export default {
  name: "shopImport",
  components: {
    Table
  },
  data() {
    return {
      loading: false,
      submitLoading: false,
      tableThData: [
        { prop: "mallId", label: "商场", minWidth: "180", },
        { prop: "name", label: "店铺名称", minWidth: "180", },
        { prop: "refId", label: "店铺编号", minWidth: "180", },
        { prop: "category", label: "所属业态", minWidth: "180", },
      ],
      tableTrData: [],
      excelData: [],
      File: null,

      mallData: [], // 商场下拉框数据
      shopCategoryData: [], // 所属业态数据
      categoryCascaderProps: {
        value: "name",
        label: "name",
      }, // 业态级联框配置项
    };
  },
  created() {
    this.getConfigData() // 获取商场、业态数据
  },
  methods: {
    // 获取商场、业态数据
    async getConfigData() {
      const {mall, category} = await api_getConfig(['mall', 'category'])
      this.mallData = mall
      this.shopCategoryData = category
    },

    // 点击下载模板按钮
    async onDownloadTemplate() {
      try {
        const res = await api_getShopTempDown()
        console.log('res: ', res);
        downFile(res) // 下载
      } catch {
        this.$baseMessage('模板下载失败', 'error')
      }
    },

    // 文件拖拽事件
    handleDrop(e) {
      e.stopPropagation()
      e.preventDefault()
      if (this.loading) return
      const files = e.dataTransfer.files
      if (files.length !== 1) {
        this.$message.error('仅支持上传一个文件!')
        return
      }
      const rawFile = files[0] // only use files[0]

      if (!this.isExcel(rawFile)) {
        this.$message.error('仅支持上传.xlsx，.xls，.csv后缀文件')
        return false
      }

      this.upload(rawFile)
      e.stopPropagation()
      e.preventDefault()
    },

    // 文件拖拽事件
    handleDragover(e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },

    // 点击上传文件按钮
    handleUpload() {
      this.$refs['excel-upload-input'].click()
    },


    handleClick(e) {
      const files = e.target.files
      const rawFile = files[0] // only use files[0]
      if (!rawFile) return
      this.upload(rawFile)
    },

    // 上传文件
    upload(rawFile) {
      console.log('rawFile: ', rawFile);
      this.$refs['excel-upload-input'].value = null // fix can't select the same excel
      this.File = rawFile // 存储File文件
      this.readerData(rawFile) // 解析excel
    },

    readerData(rawFile) {
      this.loading = true
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const workbook = XLSX.read(data, { type: 'array' }) // 读取表格文件属性
          const firstSheetName = workbook.SheetNames[0] // 获取第一个sheet名
          const worksheet = workbook.Sheets[firstSheetName] // 获取第一个sheet数据

          const headers = this.getHeaderRow(worksheet) // 获取表格头部数据
          const results = XLSX.utils.sheet_to_json(worksheet) // 获取表格主体数据
          this.generateData({ headers, results }) // 产生json数据
          this.loading = false
          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
      })
    },

    // 获取表格头部数据
    getHeaderRow(sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
        /* find the cell in the first row */
        let hdr = 'UNKNOWN ' + C // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },

    // 产生json数据
    generateData({ headers, results }) {
      this.excelData.headers = headers
      this.excelData.results = results.slice(1)

      this.tableTrData = results.slice(1)
    },

    // 点击提交
    async onSubmit() {
      // 处理表格数据
      this.tableTrData.forEach(item => {
        if (item.category) {
          item.category = Array.isArray(item.category) ? item.category.join(',') : item.category
        }
      })
      console.log('this.tableTrData', this.tableTrData)

      // return
      // const res = await api_postShopBatchAdd(this.tableTrData)
      // console.log('res: ', res);
    },

    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    }
  },
};
</script>

<style lang="scss" scoped>
.shop-import {
  padding: 35px 20px;
  padding-bottom: 100px;

  .title {
    height: 22px;
    line-height: 22px;
    font-size: 16px;
    color: #333333;
  }

  .table-box {
    margin-top: 10px;
  }

  .import-area {
    border: 1px solid #ccc;
    margin: 10px 0;
    margin-bottom: 20px;
    border-radius: 2px;

    .excel-upload-input{
      display: none;
      z-index: -9999;
    }

    .drop{
      width: 100%;
      height: 300px;
      margin: 0 auto;
      color: #bbb;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      i {
        font-size: 40px;
        color: #ccc;
        font-weight: 700;
        // margin: 20px 0;
        margin-top: 40px;
      }

      span {
        margin-top: 20px;
        color: #999999;
        font-size: 12px;
      }

      .btn-box {
        margin-top: 20px;
      }
    }
  }

  .footer{
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    z-index: 100;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
  }
}
</style>
